import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
// import { Button, Col, Row } from "reactstrap";
import EInput, {EButton}  from 'src/Components/EInput';
import { IUnitOfMeasure } from 'src/Interfaces/AdminInterface';
import { IRegion } from 'src/Interfaces/WellInterface';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import TenantStore from 'src/Stores/Tenant/TenantStore';
import { UserStore } from 'src/Stores/User/UserStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { IEBPExpenseType, IProduct } from '../../../../Interfaces/TestInterface';
import DataService from '../../../../Services/Data';
import DataTable from '../../../DataTable';


interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class AdminProducts extends React.Component {
    public props: any;
    public adminStore: AdminStore;
    public productsDisposer: any; 
    public products: IProduct[] = [];
    public productList: IList;
    public dataService: any = new DataService();
    public expenseTypesDisposer: any;
    public unitOfMeasureDisposer: any;
    private UserStore: UserStore;
    private TenantStore: TenantStore;
    private MessageStore: any;
    private units: IUnitOfMeasure[] = [];
    private unitOfMeasure: IUnitOfMeasure = new IUnitOfMeasure();

    private tableHeaders: any[] = [
        { content: 'Product', 'class': 'align-left' },
        { content: 'Primary Category', 'class': 'align-left' },
        { content: 'Taxable', 'class': 'align-left'},
        { content: 'Unit Size', 'class': 'align-left' },
        { content: 'Unit of Measure', 'class': 'align-left' },
        { content: 'Specific Gravity', 'class': 'align-left' },
        { content: 'Weight', 'class': 'align-left' },
        { content: 'Cost', 'class': 'align-left' },
        { content: 'Retail Price', 'class': 'align-left' }
    ];

    private expenseTableHeaders: any[] = [
        { content: 'Name', 'class': 'align-left' },
        { content: 'Type', 'class': 'align-left' },
        { content: 'Taxable', 'class': 'align-left' },
        { content: 'Cost', 'class': 'align-left' },
        { content: 'Price', 'class': 'align-left' },
    ]; 


    private unitOfMeasureHeaders: any[] = [
        { content: 'Name', 'class': 'align-left' },
        { content: 'Unit Size', 'class': 'align-left' }
    ];

    public state = {
        editing: false,
        expenseTypes: [] as IEBPExpenseType[],
        formattedExpenseTypeData: undefined as unknown as IList,
        formattedProductsData: this.productList,
        modal: false,
        products: this.products,
        regionData: this.productList,
        regions: [] as IRegion[],
        rowIndex: 0,
        selectUnits: new IUnitOfMeasure(),
        showDefault: false,
        showExpense: false,
        showRegion: true,
        showUOM: false,
        unitOfMeasure: this.unitOfMeasure,
        unitOfMeasureData: this.productList,
        unitOfMeasureTypes: [] as IUnitOfMeasure[],
        units: this.units,
    };

    constructor(props: any) {
        super(props);
        this.UserStore = this.props.stores.UserStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.adminStore = this.props.stores.AdminStore;
        this.TenantStore = this.props.stores.TenantStore;

        this.state.editing = false;
    }

    public componentDidMount() {

        this.createDisposers();
        if (this.UserStore.hasPermission('Permissions.Admin.Inventory.Read')) {
            this.adminStore.getProducts();
            this.adminStore.getExpenseTypes();

        if (this.UserStore.hasPermission('Permissions.Admin.UnitOfMeasure.Read')) {
            this.adminStore.getUnitOfMeasures();
        }
           
        }


        if (this.UserStore.hasPermission('Permissions.Admin.Regions.Read')) {
            this.adminStore.getRegions()
                .then(regions => this.setState({regions}, () => this.formatRegionDataTable()));
        }
            // .catch(error => console.error(error))
            // .then(data => this.formatRegionDataTable());

     
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.productsDisposer = intercept(this.adminStore, 'products', (change: any) => {
            let data = change.newValue;

            data = this.dataService.sort(data, { name: 'asc' });

            this.setState({
                products: data
            });

            this.formatDataTable();

            return change;
        });

        this.expenseTypesDisposer = intercept(this.adminStore, 'expenseTypes', (change: any) => {
            let data = change.newValue;

            data = this.dataService.sort(data, { name: 'asc' });

            this.setState({
                expenseTypes: data
            });

            this.formatExpenseDataTable();

            return change;
        });

        this.unitOfMeasureDisposer = intercept(this.adminStore, 'unitOfMeasures', (change: any) => {
            let data = change.newValue;

            data = this.dataService.sort(data, { name: 'asc' });

            this.setState({
             units: data
            });

            this.formatUOMTable();

            return change;
        });

       
    }

    private toggleModal = (name: string) => () => {
        this.setState({[name]: !this.state[name]});
    }

    private toggleShowDefault = () => {
        this.setState({showDefault: !this.state.showDefault});
    }

    private toggleShowRegion = () => {
        this.setState({showRegion: !this.state.showRegion});
    }
    private toggleShowUOM = () => {
        this.setState({showUOM: !this.state.showUOM});
    }


    private toggleUOMModal = () => {
        if (this.state.modal) {
            const UOM = new IUnitOfMeasure();
            UOM.unitSize = [''];
            this.setState({
                UOM,
                editing: false,
                modal: !this.state.modal
            });
        } else {
            this.setState({
                modal: !this.state.modal
            });
        }
    }

    private handleSelect = (index: number) => {
        const UOM = this.state.unitOfMeasure[index];
        this.setState({
         UOM
        });
    }
 

    public clearDisposers() {
        this.productsDisposer();
        this.expenseTypesDisposer();
        this.unitOfMeasureDisposer();
    }

    public rendername(product: IProduct) {
        return(
            <Link to={'/admin/products/' + product.id}>{product.name}</Link>
        );
    }

    public renderRegionName = (region: IRegion) => () => {
        return(
            <Link to={'/admin/regions/' + region.id}>{region.name}</Link>
        );
    }


    public formatDataTable() {
        let formattedData = [] as any[];
        if (this.state.formattedProductsData){
            formattedData = this.state.formattedProductsData.rows;
            formattedData.splice(0);
        }
        this.state.products.map((product: IProduct, index: number) => {
            const row = [
                {
                    'class': 'align-left',
                    content: this.rendername.bind(this, product),
                    sortItem: product.name,
                    type: 'render'
                },
                {
                    content: product.categorys && product.categorys[0] ? product.categorys[0].name : ''
                },
                {
                    content: product.isTaxable ? 'Yes' : 'No',
                },
                {
                    content: product.size
                },
                {
                    content: product.unit
                },
                {
                    content: product.specificGravity
                },
                {
                    content: product.weight
                },
                {
                    'class': 'align-left',
                    content: '$' + Number(product.cost).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                },
                {
                    'class': 'align-left',
                    content: '$' + Number(product.retailPrice).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }
            ];
            formattedData.push(row);
        });

        this.setState({
            formattedProductsData: {
                headers: this.tableHeaders,
                rows: formattedData
            }
        });
    }

    public renderExpenseTypeName(expenseType: IEBPExpenseType) {
        return(
            <Link to={'/admin/expenseTypes/' + expenseType.id}>{expenseType.name}</Link>
        );
    }

    public formatExpenseDataTable() {
        const formattedData: any[] = [];
        this.state.expenseTypes.map((expenseType: IEBPExpenseType, index: number) => {
            const row = [
                {
                    'class': 'align-left',
                    content: this.renderExpenseTypeName.bind(this, expenseType),
                    sortItem: expenseType.name,
                    type: 'render'
                },
                {
                    'class': 'align-left',
                    content: expenseType.isRental === true ? 'Rental' : 'Service'
                },
                {
                    content: expenseType.isTaxable ? 'Yes' : 'No',
                },
                {
                    'class': 'align-left',
                    content: '$' + Number(expenseType.cost).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                },
                {
                    'class': 'align-left',
                    content: '$' + Number(expenseType.retailPrice).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }
            ];
            formattedData.push(row);
        });

        this.setState({
            formattedExpenseTypeData: {
                headers: this.expenseTableHeaders,
                rows: formattedData
            }
        });
    }

    private handleCancel = () => {
        this.setState({
            UOM: new IUnitOfMeasure(),
            editing: false
        });
        this.toggleUOMModal();
    }

    private handleEdit = (index: number) => {
        const UOM = DeepCopy(this.state.units[index]);
        this.setState ({
        editing: true,
        rowIndex: index,
        unitOfMeasure: UOM
        });
        this.toggleUOMModal();
    }


    private addUnitSize = () => {
        const UnitOfMeasure = this.state.unitOfMeasure;
        const tempUnitSize = UnitOfMeasure.unitSize[UnitOfMeasure.unitSize.length -1 ]
        ? UnitOfMeasure.unitSize[UnitOfMeasure.unitSize.length - 1]
        : 0;
        UnitOfMeasure.unitSize.push(tempUnitSize);
        this.setState({
            UnitOfMeasure
        });
    }

    private editUnitSize = (event: any) => {
        const index = event.target.getAttribute("data-index");
        const UnitOfMeasure = this.state.unitOfMeasure;
        UnitOfMeasure.unitSize[index] = event.target.value;
        this.setState({
            UnitOfMeasure
        });
    }

    private removeUnitSize = (index: number) => (event: any) => {
        const unitSize = this.state.unitOfMeasure;
        unitSize.unitSize.splice(index, 1);
        this.setState({
            unitSize
        });
    }

    private handleModalInputChange = (event: any) => {
        if (!this.state.editing) {
            const UOM = this.state.unitOfMeasure;
          //  const limit = 20;
         UOM[event.target.name] = event.target.value;

            // if(UOM[event.target.name].length === 20)
            // {
            //    this.MessageStore.addMessage('Unit Of Measure Name Cannot Be More Than 20 Characters Including Spaces, Please Make Your Name Shorter.', 'warning');
            // }

            this.setState({
                UOM,
            });
        } else {
            const UOM = this.state.unitOfMeasure;
            UOM[event.target.name] = event.target.value;
            this.setState({
                UOM
            });
        }
    }

    private handleSaveUOM = () => {
        this.saveUOMLogic();
        this.setState({
            unitOfMeasure: new IUnitOfMeasure(),
            uomModalOpen: false,
        });
        this.formatUOMTable();
        this.toggleUOMModal();
    }

    public handleDelete = (index: number) => {
        const unitToDelete = this.state.units[index];
        this.adminStore.deleteUnitOfMeasure(unitToDelete.id)
            .then( data => {
                if (data) {
                    this.MessageStore.addMessage(' Unit Of Measure Deleted', 'success');
                }
                this.adminStore.getUnitOfMeasures();
            }
            );
            this.formatUOMTable();
    }

    private saveUOMLogic = () => {
        if (!this.state.editing){
        this.adminStore.saveUnitOfMeasure(this.state.unitOfMeasure)
            .then(
                (data: any) => {
                    if (data) {
                        const message = 'Changes have been saved';
                        this.MessageStore.addMessage(
                            message,
                            'success'
                        );
                        this.adminStore.getUnitOfMeasures();
                    }
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'there was an erorr in saving UOM'
                    );
                }
            );
        } else {
            this.adminStore.putUnitOfMeasure(this.state.unitOfMeasure)
            .then(
                (data: any) => {
                    if (data) {
                        const message = 'Changes have been saved';
                        this.MessageStore.addMessage(
                            message,
                            'success'
                        );
                        this.adminStore.getUnitOfMeasures();
                    }
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'there was an erorr in saving UOM'
                    );
                }
            );
        }
    }

    private displayAddUnitOfSizeButton() {
        if (this.state.editing) {
            return this.addUnitOfSizeEditButton();
        }
        return this.addJetSizeButtonAdd();
    }

    private addUnitOfSizeEditButton() {
        const size: any[] = this.state.unitOfMeasure.unitSize;
        const length = size.length;
        const isEditing = this.state.editing;
        const hasUnitSize = (length > 0);
        const lastUnitSizeNotZero = (hasUnitSize) ? Number(size[length - 1]) !== 0 : true;
        return (isEditing && lastUnitSizeNotZero);
    }

    private addJetSizeButtonAdd() {
        const UOM = this.state.unitOfMeasure.unitSize;
        const length = UOM.length;
        const isEditing = this.state.editing;
        const hasUnitSizes = (length > 0);
        const lastUnitSizeNotZero = (hasUnitSizes) ? Number(UOM[length - 1]) !== 0 : true;
        return (!isEditing && (length === 0 || lastUnitSizeNotZero));
    }


    public formatUOMTable() {
        const uom = this.state.units;
        const formattedData: any[] = [];
        uom.map((UOM: IUnitOfMeasure, index: number) => {
            const row = [
                {
                    'class': 'align-left',
                    content: UOM.name,
                },
                {
                    'class': 'align-left',
                    content: `${UOM.unitSize},`.replace(/,\s*$/, ""),
                    sortItem: UOM.unitSize.sort((a: any,b: any) => a - b)
                }
            ];
            formattedData.push(row);
        });
        this.setState({
            unitOfMeasureData: {
                 headers: this.unitOfMeasureHeaders,
                 rows: formattedData
                }
        });
    }

    public formatRegionDataTable() {
        const rows: any[] = [];
        this.state.regions.forEach((region: IRegion, index:number) => {
            const row = [
                {
                    content: this.renderRegionName(region),
                    sortItem: region.name,
                    type: 'render',
                },
                {
                    content: region.state
                }
            ];
            rows.push(row);
        });

        const headers = [
            {
                content: "Region"
            },
            {
                content: "State"
            }
        ];

        this.setState({
            regionData: {headers, rows}
        });
    }

    public render() {
        const hasInventoryPerm = this.UserStore.hasPermission('Permissions.Admin.Inventory.Read');
        const hasRegionPerm = this.UserStore.hasPermission('Permissions.Admin.Regions.Read');
        const hasUnitOfMeasurePerm = this.UserStore.hasPermission('Permissions.Admin.UnitOfMeasure.Read');
        return(
            <div>
                {
                    hasRegionPerm && 
                    <React.Fragment>
                        <Row className="header">
                            <Col>
                                <h4 onClick={this.toggleShowRegion}>
                                    <FontAwesomeIcon   
                                        icon="chevron-right"
                                        color={this.TenantStore.iconColor}
                                        rotation={ this.state.showRegion ?
                                            90 : 270
                                        }
                                        transform="shrink-2"
                                        style={{marginRight: '10px'}}
                                    />
                                Regions List</h4>
                            </Col>
                        </Row>
                        { this.state.showRegion && 
                        <React.Fragment>
                            <Row className="header">
                                <Col md="6">
                                    <h1>Regions</h1>
                                </Col>
                                <Col md="6">
                                    {
                                        this.UserStore.hasPermission('Permissions.Admin.Regions.Create') &&
                                        <Link to="/admin/regions/new">
                                            <Button color="primary" className="float-right">
                                                Add New Region
                                            </Button>
                                        </Link>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <DataTable list={this.state.regionData} />
                                </Col>
                            </Row>
                        </React.Fragment>
                        }
                    </React.Fragment>
                }
                {
                    hasInventoryPerm &&
                    <React.Fragment>
                        <Row className="header">
                            <Col>
                                <h4 onClick={this.toggleShowDefault}>
                                    <FontAwesomeIcon   
                                        icon="chevron-right"
                                        color={this.TenantStore.iconColor}
                                        rotation={ this.state.showDefault ?
                                            90 : 270
                                        }
                                        transform="shrink-2"
                                        style={{marginRight: '10px'}}
                                    />
                                Master Retail Product List</h4>
                            </Col>
                        </Row>
                        {
                        this.state.showDefault &&
                        <React.Fragment>
                            <Row className="header">
                                <Col md="12">
                                    { 
                                        this.UserStore.hasPermission('Permissions.Admin.Inventory.Create') &&
                                        <Link to="/admin/products/new">
                                            <Button color="primary" className="float-right">
                                                Add New Product
                                            </Button>
                                        </Link>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12">
                                    <DataTable list={this.state.formattedProductsData} />
                                </Col>
                            </Row>
                        </React.Fragment>
                        }
                        <Row className="header">
                            <Col>
                                <h4 onClick={this.toggleModal('showExpense')}>
                                    <FontAwesomeIcon   
                                        icon="chevron-right"
                                        color={this.TenantStore.iconColor}
                                        rotation={ this.state.showExpense ?
                                            90 : 270
                                        }
                                        transform="shrink-2"
                                        style={{marginRight: '10px'}}
                                    />
                                Master Retail EBP List</h4>
                            </Col>
                        </Row>
                        {
                            this.state.showExpense &&
                            <React.Fragment>
                                <Row className="header">
                                    <Col md="12">
                                        {
                                            this.UserStore.hasPermission('Permissions.Admin.Inventory.Create') &&
                                            <Link to="/admin/expenseTypes/new">
                                                <Button color="primary" className="float-right">
                                                    Add New EBP Item
                                                </Button>
                                            </Link>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="12">
                                        <DataTable list={this.state.formattedExpenseTypeData} />
                                    </Col>
                                </Row>
                            </React.Fragment>
                        }
                    </React.Fragment>
                }

                {
                    hasUnitOfMeasurePerm &&
                    <React.Fragment>
                        <Row className="header">
                            <Col>
                                <h4 onClick={this.toggleShowUOM}>
                                    <FontAwesomeIcon
                                        icon="chevron-right"
                                        color={this.TenantStore.iconColor}
                                        rotation={this.state.showUOM ?
                                            90 : 270
                                        }
                                        transform="shrink-2"
                                        style={{ marginRight: '10px' }}
                                    />
                                    Master Unit Of Measure List</h4>
                            </Col>
                        </Row>
                        {this.state.showUOM &&
                            <React.Fragment>
                                <Row className="header">
                                    <Col md="6">
                                        <h1>Units Of Measure</h1>
                                    </Col>
                                    <Col md="6">
                                        {
                                            this.UserStore.hasPermission('Permissions.Admin.UnitOfMeasure.Create') &&
                                                <Button color="primary" className="float-right" onClick={this.toggleUOMModal}>
                                                    Add New Unit Of Measure
                                                </Button>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="12">
                                        <DataTable 
                                        list={this.state.unitOfMeasureData}
                                        // onNew={{
                                        //     callback: this.toggleUOMModal
                                        // }}
                                        onSelect={this.handleSelect}
                                        onEdit={this.handleEdit}
                                        onDelete={this.UserStore.hasPermission('Permissions.Admin.UnitOfMeasure.Delete') ? this.handleDelete : undefined}
                                        />
                                    </Col>
                                </Row>
                            </React.Fragment>
                        }
                    </React.Fragment>
                }

                <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleUOMModal} backdrop="static">
                    <ModalHeader toggle={this.toggleUOMModal}>
                        {this.state.editing ? 'Edit Unit Of Measure' : 'Add New Unit Of Measure'}
                    </ModalHeader>
                    <Form>
                        <ModalBody>
                            <Row>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Name</Label>
                                        <EInput
                                            type="text"
                                            name="name"
                                            id="name"
                                            required={true}
                                            value={this.state.unitOfMeasure.name}
                                            onChange={this.handleModalInputChange}
                                            data-validation='unitOfMeasure'
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <hr />
                                </Col>
                                <Col md="12">
                                    <FormGroup className="required">
                                        <Label>Unit Of Measure Sizes</Label>
                                    </FormGroup>
                                    <FormGroup row={true}>
                                        {this.state.unitOfMeasure.unitSize &&
                                            this.state.unitOfMeasure.unitSize.map((size: number, index: number) =>
                                                <React.Fragment key={index}>
                                                    <Col xs="2" style={{ 'marginTop': 5, paddingLeft: 10, paddingRight: 2 }}>
                                                        <EInput
                                                            type="text"
                                                            value={size}
                                                            data-validation="integer"
                                                            required={true}
                                                            data-index={index}
                                                            onChange={this.editUnitSize}
                                                        />
                                                    </Col>
                                                    <Label xs="1" style={{ 'marginTop': 5, paddingLeft: 2, paddingRight: 2 }} onClick={this.removeUnitSize(index)}>
                                                        <FontAwesomeIcon icon={['far', 'trash-alt']} />
                                                    </Label>
                                                </React.Fragment>
                                            )}
                                    </FormGroup>
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button className="secondary" onClick={this.handleCancel}>Cancel</Button>
                            {this.displayAddUnitOfSizeButton() &&
                                <Button color="primary" onClick={this.addUnitSize}>Add Unit Size</Button>
                            }
                            {this.state.editing ? 
                            <EButton color="primary" onClick={this.handleSaveUOM}>Update</EButton>
                            :
                            <EButton color="primary" disabled={this.state.unitOfMeasure.name.length >= 20} onClick={this.handleSaveUOM}>Save</EButton>
                            }
                        </ModalFooter>
                    </Form>
                </Modal>
            </div>
        );
    }

}

export default AdminProducts;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Products/AdminProducts.tsx